import * as React from 'react';
const ArtrosiIcon = ({ primaryColor, secondaryColor, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-1,.prefix__cls-2{stroke:${secondaryColor ||
        '#ffcf38'};fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px}.prefix__cls-2{stroke:${primaryColor ||
        '#282828'}}`}</style>
    </defs>
    <path
      d="M84.99 50.35v24.14c0 2.83-1.54 5.4-3.97 6.84-3 1.79-4.96 5.16-4.7 8.96.32 4.82 4.23 8.69 9.05 8.97 3.77.22 7.1-1.73 8.88-4.71M107.75 81.49c-2.3-1.47-3.71-3.99-3.71-6.72V50.35M103.51 149.65v-24.14c0-2.83 1.54-5.4 3.97-6.84M94.25 103.51c-2.22 2.55-5.5 3.96-8.96 3.76-2.64-.15-5.03-1.24-6.85-2.93a9.56 9.56 0 0 0-2.14 5.89 9.66 9.66 0 0 0 4.45 8.28c2.3 1.47 3.71 3.99 3.71 6.72v24.42"
      className="prefix__cls-2"
    />
    <circle cx={113.04} cy={100} r={10.67} className="prefix__cls-1" />
    <circle cx={113.04} cy={100} r={1.52} className="prefix__cls-1" />
  </svg>
);
export default ArtrosiIcon;
